import { create } from "zustand";
import { persist, subscribeWithSelector } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";

export type Language = "en" | "zh" | "jp";

export type UserSettings = {
  language?: string;
  timeZone?: string;
  dateFormat?: string;
  timeFormat?: string;
  [key: string]: any;
};

export type TenantSettings = {
  dateFormat?: string;
  language?: string;
  timeZone?: string;
  timeFormat?: string;
  [key: string]: any;
};

type ConfigStore = {
  language: Language;
  updateLanguage: (data: Language) => void;
  userSettings: UserSettings | null;
  updateUserSettings: (data: UserSettings | null) => void;
  tenantSettings: TenantSettings | null;
  updateTenantSettings: (data: TenantSettings | null) => void;
};

export const useConfigStore = create<ConfigStore>()(
  persist(
    subscribeWithSelector(
      immer((set, get) => ({
        language: "en",
        updateLanguage(data: Language) {
          set((state) => {
            state.language = data;
          });
        },
        userSettings: null,
        updateUserSettings(data: UserSettings | null) {
          set((state) => {
            state.userSettings = data;
          });
        },
        tenantSettings: null,
        updateTenantSettings(data: TenantSettings | null) {
          set((state) => {
            state.tenantSettings = data;
          });
        },
      }))
    ),
    {
      name: "global-config-store",
      partialize: (state) => ({
        userSettings: state.userSettings,
        tenantSettings: state.tenantSettings,
      }),
    }
  )
);
